import { render } from "./AppFriends.vue?vue&type=template&id=60f17f2f&scoped=true"
import script from "./AppFriends.vue?vue&type=script&lang=js"
export * from "./AppFriends.vue?vue&type=script&lang=js"

import "./AppFriends.vue?vue&type=style&index=0&id=60f17f2f&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f17f2f"]])

export default __exports__